import apiClient from './client'

export const categoryService = {
  getCategories: () => apiClient.get('/categories'),

  createCategory: (data) => apiClient.post('/categories', data),

  getCategoryById: (id) => apiClient.get(`/categories/${id}`),

  updateCategory: (id, data) => apiClient.put(`/categories/${id}`, data),

  deleteCategory: (id) => apiClient.delete(`/categories/${id}`),
}

export default categoryService
